import PlusIcon from '@common/components/icons/PlusIcon';
import * as styles from './index.module.css';

export default function CreateButton({ label, onClick }) {
  return (
    <button
      onClick={onClick}
      className={styles['create-button']}
      type="button"
    >
      <span className={styles['create-button-icon']}>
        <PlusIcon color="#ffffff" />
      </span>
      <span className={styles['create-button-label']}>{label}</span>
    </button>
  );
}

